export default __webpack_public_path__ + "images/header-profile-skin-2.png";